import React from 'react'
import PerviewVideoCarusel from './PerviewVideoCarusel';
function Preview() {
  return (
    <section id='preview' className='preview py-12 sm:py-20'>
      <div className='container px-3 mx-auto'>
        <div className='max-w-[490px] mx-auto mb-10'>
          <h2 className='text-[30px] sm:text-[40px] font-bold text-white text-center mb-2'>ПРЕВЬЮ</h2>
          <p className='text-white text-[14px] sm:text-[18px] text-center'>Оказывайте услуги клиентам вашего бизнеса с помощью лицензионной технологии CASHBOX</p>
        </div>
        <div className=' px-5 sm:px-20 lg:px-36'>
          <PerviewVideoCarusel />
        </div>
      </div>
    </section>
  )
}

export default Preview